import { Typography } from '@mui/material';

import { combineStyles, typedStyles } from '@/utils/styleUtils';

import { colors } from '@/themesConfig/colors';

import type { TStepperStepProps } from './types';

const styles = typedStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    gap: 2,
  },

  index: {
    width: 32,
    height: 32,
    lineHeight: '30px',
    textAlign: 'center',
    borderRadius: '50%',
    border: 1,
  },

  indexPassed: {
    backgroundColor: 'primary.main',
    borderColor: 'primary.main',
    color: colors.white,
  },
});

export const StepperStep = ({ index, title, passed, sx }: TStepperStepProps) => {
  const rootStyles = combineStyles(styles.root, sx);
  const indexStyles = [styles.index, passed && styles.indexPassed];

  return (
    <Typography component="div" color={passed ? 'textPrimary' : 'textSecondary'} sx={rootStyles}>
      <Typography variant="inherit" sx={indexStyles}>
        {index}
      </Typography>

      <Typography variant="inherit">{title}</Typography>
    </Typography>
  );
};
